import { render } from "./MainTab.vue?vue&type=template&id=efe1a71a"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Documents/mybackup/backup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__